/* 🤖 this file was generated by svg-to-ts */
export const matIconPhotoFilter: {
  name: 'photo-filter';
  data: string;
} = {
  name: 'photo-filter',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zm-2.94-2.06L17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7zM12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"/></svg>`
};
